import {
    minimizedChatIconActions,
    webChatMinimizedIcon
} from '../../supportTicket/supportWindow';

export class EventBankClosedHandler {
    public handle(): void {
        if (window.helpshiftWebChatState.messageCount > 0) {
            window.helpshiftWebChatState.hideChatIcon = false;
            minimizedChatIconActions(webChatMinimizedIcon.SHOW);
        }
    }
}
